import React from 'react';
import '../../styles/MobileScreener.css';

/**
 * Instagram Stories-style progress bar with ticker grouping
 * Shows grouped progress bars for each ticker with visual separation
 */
const StoryProgressBar = ({
  tickerGroups,
  currentTicker,
  currentIndexInTicker,
  allTickers
}) => {
  return (
    <div className="story-progress-grouped">
      {allTickers.map((ticker) => {
        const contracts = tickerGroups[ticker] || [];
        const isCurrentTicker = ticker === currentTicker;

        return (
          <div key={ticker} className="ticker-progress-group">
            {/* Ticker label */}
            <div className="ticker-label">
              {ticker}
            </div>

            {/* Progress bars for this ticker */}
            <div className="progress-bars">
              {contracts.map((_, index) => {
                const isActive = isCurrentTicker && index === currentIndexInTicker;
                const isPassed = isCurrentTicker ?
                  index < currentIndexInTicker :
                  allTickers.indexOf(ticker) < allTickers.indexOf(currentTicker);

                return (
                  <div
                    key={`${ticker}-${index}`}
                    className={`progress-segment ${isActive ? 'active' : ''} ${isPassed ? 'passed' : ''}`}
                  >
                    <div className="progress-fill"></div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StoryProgressBar;